<template>
  <v-row class="permissions-selector">
    <v-col cols="5" lg="5" md="5" sm="4" xs="4" class="presets-col">
      <Presets v-model="permissions" />
    </v-col>
    <v-col cols="8" lg="7" md="7" sm="8" xs="8" class="list-col">
      <v-subheader>{{ lang.permissions.title }}</v-subheader>
      <List
        :model="model"
        v-model="permissions"
      >
        <template v-slot:sub="sub1">
          <List
            :model="sub1.model"
            :value="sub1.permission"
            @input="sub1.update"
          >
            <template v-slot:sub="sub2">
              <List
                :model="sub2.model"
                :value="sub2.permission"
                @input="sub2.update"
              >
                <template v-slot:sub="sub3">
                  <List
                    :model="sub3.model"
                    :value="sub3.permission"
                    @input="sub3.update"
                  >
                  </List>
                </template>
              </List>
            </template>
          </List>
        </template>
      </List>
    </v-col>
  </v-row>
</template>

<script>
import List from './List'
import Presets from './Presets'

import defaults from '@/modules/default'
import appdata from '@/mixins/appdata'

export default {
  mixins: [ appdata ],
  components: { List, Presets },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  computed: {
    permissions: {
      get: function () {
        return this.value || {}
      },
      set: function (val) {
        this.$emit('input', val)
        this.$forceUpdate()
      }
    },
    model () {
      return defaults.permissions.model(this.lang.permissions, this.get_global.defaults.options)
    }
  },
  watch: {
    value () {
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="scss">
.permissions-selector {
  #app & {
    margin: 12px !important;
    padding: 0px !important;
    border-radius: 5px !important;
    .v-subheader {
      width: 100%;
      margin-bottom: 5px;
      padding-bottom: 2px;
      padding-left: 1px !important;
      border-bottom: 2px solid;
    }
    .v-input--checkbox {
      margin-top: 3px !important;
    }
    .list-col {
      padding: 5px 5px 25px 10px;
      .sub {
        .v-input--checkbox {
          * {
            color: rgb(244,67,54) !important;
          }
          &.selected * {
            color: rgb(76,175,80) !important;
          }
        }
        .v-select {
          margin: 5px 0px !important;
        }
      }
      .sub .sub {
        padding-left: 20px;
      }
    }
    .presets-col {
      padding: 0px !important;
      .permissions-presets {
        height: 100%;
        padding: 5px 0px 0px 0px !important;
        background: transparent !important;
        .v-subheader {
          padding-right: 0px !important;
          justify-content: center;
        }
        .v-list {
          background: transparent !important;
          border-radius: 5px !important;
          .v-list-item {
            min-height: 35px !important;
            .v-list-item__content {
              padding: 0px !important;
            }
          }
        }
      }
    }
  }
  #app.theme--light & {
    background: rgba(255,255,255,0.5) !important;
    box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%);
    .v-subheader {
      border-image: linear-gradient(to right, rgba(0, 0, 0, 0.12) 0%, rgba(0, 0, 0, 0.07) 20%, rgba(0, 0, 0, 0.07) 50%, rgba(255, 255, 255, 0) 80%, rgba(255, 255, 255, 0) 100%);
      border-image-slice: 1;
    }
    .permissions-presets {
      background-image: linear-gradient(to left, rgba(255, 255, 255, 0.7) 0%, rgba(0, 0, 0, 0) 90%) !important;
      border-right: 1.5px solid rgba(0,0,0,0.07);
      .v-subheader {
        border-image: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(0, 0, 0, 0.07) 20%, rgba(0, 0, 0, 0.07) 50%, rgba(0, 0, 0, 0.07) 80%, rgba(255, 255, 255, 0) 100%) !important;
        border-image-slice: 1 !important;
      }
      .v-list {
        .v-list-item {
          color: rgba(0, 0, 0, 0.59) !important;
          border-bottom: 1px solid rgba(0,0,0,0.07);
        }
      }
    }
  }
  #app.theme--dark & {
    background: rgba(0,0,0,0.2) !important;
    box-shadow: 0 3px 1px -2px rgb(255 255 255 / 20%), 0 2px 2px 0 rgb(255 255 255 / 14%), 0 1px 5px 0 rgb(255 255 255 / 12%);
    .v-subheader {
      border-image: linear-gradient(to right, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0.07) 20%, rgba(255, 255, 255, 0.07) 50%, rgba(0, 0, 0, 0) 80%, rgba(0, 0, 0, 0) 100%);
      border-image-slice: 1;
    }
    .permissions-presets {
      background-image: linear-gradient(to left, rgba(0, 0, 0, 0.3) 0%, rgba(255, 255, 255, 0) 90%) !important;
      border-right: 1.5px solid rgba(255, 255, 255, 0.1);
      .v-subheader {
        border-image: linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgba(255, 255, 255, 0.07) 20%, rgba(255, 255, 255, 0.07) 50%, rgba(255, 255, 255, 0.07) 80%, rgba(0, 0, 0, 0) 100%) !important;
        border-image-slice: 1 !important;
      }
      .v-list {
        .v-list-item {
          color: rgba(255, 255, 255, 0.7) !important;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        }
      }
    }
  }
}
</style>
